<template>
<Page>
 <div class="container-new-flex"  ref="lT">
  <div class="container-new">
    <div class="calendar">
      <!-- <div class="flexCenter header">
        <div class="left"></div>
        <div class="flexCenter middle">
          <img
            :src="'https://gehx.oss-cn-hangzhou.aliyuncs.com/red-cal/left.png'"
            @click="preMonth(year,month)"
            alt
          >
          <div class="month font-pfb font30">{{year}}年{{month+1}}月</div>
          <img
            :src="'https://gehx.oss-cn-hangzhou.aliyuncs.com/red-cal/right.png'"
            @click="nextMonth(year,month)"
            alt
          >
        </div>
        <div
          v-bind:class="{hidden: hidden}"
          class="right font24 cfe4 font-pfb"
          @click="goToday(today)"
        >回到今天</div>
      </div>-->
      <van-row class="listcontent">
        <van-col span="8">
          <van-icon @click="preMonth(yearM,monthM)" name="arrow-left"/>
        </van-col>
        <van-col span="8">
          <div class="month font-pfb font30">{{yearM}}年{{monthM}}月</div>
        </van-col>
        <van-col span="8">
          <van-icon @click="nextMonth(yearM,monthM)" name="arrow"/>
        </van-col>
      </van-row>
      <ul class="weekdays font-pfb font24">
        <li>日</li>
        <li>一</li>
        <li>二</li>
        <li>三</li>
        <li>四</li>
        <li>五</li>
        <li>六</li>
      </ul>
      <ul class="list-date">
           <li v-for="(item,index) in  daysList"  v-bind:key="index"  @click="clickDate(index,item.date)"  >
               <div class="days"  :class="item.edit?'active':''" >{{item.date}}</div>
               <div v-if="item.city.length>0" class="days-flex-colum" :class="item.edit?'activeBC':''" >
                    <div v-for="(items,index) in item.city " v-bind:key="index" >
                         <div class="cityDate">{{items.split(",")[1]}} {{items.split(",")[0]}}</div>
                    </div>
               </div>
           </li>
      </ul>
    </div>

    <div class="appraise">
      <span class="appraise_ico"></span> 课程信息
    </div>
    <div class="listappraise">
      <div v-if="listdata.length==0"  class="noDates">
                 {{listdata.length==0?'暂无数据':''}}
      </div>
      <van-row class="curriculum_member" v-for="(items,index)  in listdata" v-bind:key="index">
        <div @click="toDetail(items,index)" v-if="listdata.length>0">
          <van-row>
            <van-col span="24" class="name list-row-items">({{items.orderIndex}}){{items.name}}</van-col>
          </van-row>
          <van-row>
            <van-col span="16" class="teacherName">导师：{{items.teacherName}}</van-col>
            <van-col
              span="8"
              v-if="items.satus==0?true:false"
              style="color: #6F6F6F;font-weight: bold;text-align: right"
              :class="items.satus==0?'active':''"
            >已取消
              <van-icon name="arrow"/>
            </van-col>
            <van-col span="8" v-else style="color: #6F6F6F;font-weight: bold;text-align: right">
              <van-icon name="arrow"/>
            </van-col>
          </van-row>
          <van-row>
            <van-col span="24" class="courseType">类型：{{items.courseType}}</van-col>
          </van-row>
           <van-row>
            <van-col span="24" class="courseType">地点：{{items.city}}</van-col>
          </van-row>
        </div>
      </van-row>
    </div>
    </div>
  </div>
  </Page>
</template>
<script>
import $api from "../../api/lkcollege_api"; // 接口
import { Dialog, Toast } from "vant";
export default {
  name: "calendarCurriculum",
  components: {},
  data() {
    return {
      title: "日历",
      year: "", //年份
      month: "", //月份
      weekday: 1, //星期几,0为周日
      days: [
        {
          id: 0,
          date: "",
          statu: {
            statu: "",
            config: ""
          }
        }
      ], //每月的天数
      currentDay: "", //点选的日期
      today: "",
      firstDate: "", //每月第一天日期
      lastDate: "", //每月最后一天日期
      dayOfMonth: [], //每月天数
      future: false, //是否显示选项按钮
      type: "begin",
      isChecked: false,
      disabled: false,
      status: [], //当月每天对应的状态
      hidden: true, //是否隐藏回到今天
      statuClass: [
        "statu-cal",
        "statu-mense",
        "statu-safe",
        "statu-ovulation",
        "statu-mense-single",
        "statu-mense-start",
        "statu-mense-end",
        "statu-ov"
      ], //样式集合
      listdata: [
        {
          courseCalendarId: "", //日历视图id
          courseId: "", //课程id
          date: "", //日期
          courseType: "", //课程类型
          city: "", //城市
          name: "", //课程名称
          teacherName: "", //导师名称
          satus: "" //取消状态（0:已取消；1:正常）
        }
      ],
    /*================================================*/
      monthed:'',
      someDayed:'',
      yearM:"",    //年
      monthM:'',   //月
      daysList:[],
      activeColor:'red',
      weekdayM:"",
    };
  },

  watch: {},

  computed: {},
  methods: {
    //跳转详情页面
    async toDetail(item, index) {
      try {
        let { courseId } = item;
        this.$router.push({
          path: "/detailsCurriculum",
          query: { courseId, salesId: null,currentDay:this.currentDay }
        });
      } catch (error) {
        Toast("发生错误!");
      }
    },
    //课程日历视图接口
    async course_view(month, someDay) {
      try {
        let { sendSync, get } = this.$api;
        let course = await get("api/course/view", {
          salesId: this.$wxuserUtil.getUserId(),
          month: month || this.moment().format("YYYY-MM"),
          someDay: someDay
        });
        //查询失败
        if (!course.success) {
          Toast(course.msg);
          return;
        }
        this.listdata = course.data;
        // Toast(course.msg);
      } catch (error) {
        console.log(error);
        Toast("发生错误");
      }
    },
    /**
     * 初始化日历(不含状态)
     * @param  {Data}  param [需要进行渲染的日期对象]
     * @return {[type]} [description]
     */
    initCalendar: function(param) {
      this.days = [];
      let date = new Date();

      if (param) {
        date = param;
      }
      date.setDate(1); //设置当月日期为1
      this.getSatAndSun(date.getFullYear(), date.getMonth() + 1);

      this.weekday = date.getDay();
      this.year = date.getFullYear();
      this.month = date.getMonth();

      let temp = new Date(this.year, this.month + 1, 0);

      this.lastDate = this.formatDate(
        this.year,
        this.month + 1,
        temp.getDate()
      );
      this.firstDate = this.formatDate(this.year, this.month + 1, 1);

      this.dayOfMonth = [
        31,
        28 + this.isLeapYear(this.year),
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ]; //每个月的天数
      this.fillDays([]);
    },
    /**
     * 判断是否问闰年
     * @param  {[type]}  year [需要判断的年份]
     * @return {Boolean}      [description]
     */
    isLeapYear: function(year) {
      if ((year % 4 == 0 && year % 100 != 0) || year % 400 == 0) {
        return true;
      } else {
        return false;
      }
    },

    /**
     * 选择日期回调
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    bindClickDay: function(e) {
      console.log("输入日历数组",this.days)
      var day = "";
      if (e.target.nodeName != "UL") {
        day = this.closet(e);
      }
      if (day != "") {
        this.currentDay = day;

        if (
          parseInt(this.today.split("-").join("")) <
          parseInt(this.currentDay.split("-").join(""))
        ) {
          this.future = true;
          this.condition = false;
        } else {
          this.future = false;
          // this.changeCheckBox(this.currentDay);
          // this.getStatuData(this.currentDay, false, true);
        }
      }
      //点击日期加载数据
      let month;
      month =
        (this.month + 1).toString().length == 1
          ? "0" + (this.month + 1)
          : this.month + 1;
      this.course_view(this.year + "-" + month, this.currentDay);
      // this.fillDays(this.filljqData(["2018-05-18"], [ "2018-05-19"], this.status));
    },
    //回到今天
    goToday: function(today) {
      // this.currentDay = today;
      this.hidden = true;
      this.initCalendar(new Date(today));
      // this.getStatuData("", true, false);
    },

    /**
     * 检查是否是今天的月份，如果是则显示“回到今天”否则不显示
     * @param  {String}  year  [需要验证的年份]
     * @param  {String}  month [需要验证的月份]
     * @return {Boolean}       [当前月为true]
     */
    isTodayMonth: function(year, month) {
      let todayArr = this.today.split("-");
      if (year == todayArr[0] && month + 1 == todayArr[1][1]) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },

    closet: function(e) {
      var temp = e.target;
      while (1) {
        if (temp.nodeName == "LI") {
          return temp.getAttribute("date");
        } else {
          temp = temp.parentNode;
        }
      }
    },

    /**
     * 获取当月的所有周日和周六日期
     * @param  {[type]} year  [description]
     * @param  {[type]} month [description]
     */
    getSatAndSun: function(year, month) {
      let tempTime = new Date(year, month, 0);
      let time = new Date();
      let saturday = [];
      let sunday = [];

      for (var i = 1; i <= tempTime.getDate(); i++) {
        time.setFullYear(year, month - 1, i);
        var day = time.getDay();
        if (day == 6) {
          saturday.push(i);
        } else if (day == 0) {
          sunday.push(i);
        }
      }
      this.saturdays = saturday;
      this.sundays = sunday;
    },

    /**
     * 分配不同状态的class
     * @param  {[type]} day [description]
     * @return {[type]}     [description]
     */
    checkClass: function(day) {
      let me = this;
      if (this.saturdays.indexOf(day.date) != -1) {
        if (day.statu.statu == 1 || day.statu.statu == 6) {
          return "statu-mense-end";
        } else if (day.statu.statu == 5 || day.statu.statu == 4) {
          return "statu-mense-single";
        }
      }

      if (this.sundays.indexOf(day.date) != -1) {
        if (day.statu.statu == 1 || day.statu.statu == 5) {
          return "statu-mense-start";
        } else if (day.statu.statu == 6 || day.statu.statu == 4) {
          return "statu-mense-single";
        }
      }

      if (
        day.statu.statu == 1 ||
        day.statu.statu == 4 ||
        day.statu.statu == 5 ||
        day.statu.statu == 6
      ) {
        let className = me.statuClass[day.statu.statu];
        return className;
      }
    },
    getDayConfig: function(statu, config) {
      return {
        statu: statu || 0,
        config: config || false
      };
    },

    /**
     * 填装状态
     * @return {[type]} [description]
     */
    fillDays: function(status) {
      // let tempStatus = this.parseStatus(status);
      let me = this;
      let tempStatus = status;
      let tempDays = [];
      //装配目标月份日期
      for (let i = 1; i <= this.dayOfMonth[this.month]; i++) {
        let tempObj = {
          id: i,
          date: i,
          statu: tempStatus[i - 1] || me.getDayConfig("2")
        };
        tempDays.push(tempObj);
      }
      // if(status.length ! = 0){
      this.days = tempDays;
      // }

      //装配目标月份空白天数
      for (let i = 1; i <= this.weekday; i++) {
        this.days.unshift({
          id: "e" + i,
          date: "",
          statu: me.getDayConfig("2")
        });
      }
    },


    /**
     *
     * =====================================================================================
     *                                        重置
     * =====================================================================================
     *
     */


    //日历视图
    getCalendarCourseView(monthed,someDayed){
      let data={
        salesId:this.$wxuserUtil.getUserId(),
        month:monthed||'',
        someDay:someDayed||'',
      };
      this.$api.getCalendarCourseView(data).then(Response=>{
          console.log("日历视图",Response)
          if(Response.success){
            let city=Response.data.calendarList
            console.log(city,'城市')
            let $data=[];
                $data=this.daysList;
                    for(let i=0;i<$data.length;i++){
                         for(let m=0;m<city.length;m++){
                             if($data[i]['allDate']==city[m]['dateNum']){
                                  console.log("相等",$data[i])
                                  $data[i]['city']=city[m]['U_SynStatus'].length>0?city[m]['U_SynStatus']:[]
                             }
                         }
                    }
                    this.daysList=$data;
                    this.listdata=Response.data.courseList;
          }else{
             this.$title("请求异常")
          }
      })
    },
    //获取当月多少天
    getNowDay(ID,$year,$month){
        var aDate = new Date();
        let year,month,day;
        if(ID==1){
         year  =  aDate.getFullYear();
         month =  aDate.getMonth()+1;
         day   =  0;
        }
        if(ID==2){
         ear    =  $year;
         month  =  $month;
         day    =  0;
        }
        var  days = new Date(this.yearM,this.monthM,day);
        var daycount = days.getDate();
        return  daycount;
    },
    //循环处理日历长度 push给数组
    dayListPush(ID){
        console.log('当月第一天星期几',this.firstDayWeek())
        let dayList=[];
        let weekList=[];
        for(let o=0;o<this.firstDayWeek();o++){
           weekList.push({
              city:[],
              date:'',
              id:0,
              edit:false,
           })
        }
        if(ID==1){
        for(let i=1;i<=this.getNowDay(1);i++){
           dayList.push({
              city:[],
              date:i,
              id:1,
              edit:false,
              color:"",
              allDate: parseInt(this.yearM+this.monthM+i),
              indexs:parseInt( this.weekdayM+i-1)
           })
        }}else{
        for(let i=1;i<=this.getNowDay(1,this.yearM,this.monthM);i++){
           dayList.push({
              city:[],
              date:i,
              id:1,
              edit:false,
              color:"",
              allDate: parseInt(this.yearM+this.monthM+i),
              indexs:parseInt( this.weekdayM+i-1)
           })
         }
        }
        this.daysList=weekList.concat(dayList);
        //  this.getCalendarCourseView();
    },
    //计算当月第一天星期几
    firstDayWeek(year,month){
          //当前月当天日期对象：
          var date=new Date(this.yearM,this.monthM-1,1);
          //当前月第一天日期对象：
          date=new Date(date.setDate(1))
          //当前月第一天星期几:
          var weekday=date.getDay();
          this.weekdayM=weekday;
          return weekday;
    },
    // 判断当前日期 改为红点
    firstDateDay(){
        var myDate  =  new Date();
        var index   =  myDate.getDate()
        console.log(index,'mmmmmmmmmmmmmm')
        let list   =[]
          list=this.daysList;
        list[parseInt(this.weekdayM+index-1)]['edit']=true;
        list[parseInt(this.weekdayM+index-1)]['color']='red';
        console.log(list,'ssssssssssssssssssssss')
        this.daysList=list;

    },
    //点击日期
    clickDate(index,day){
      console.log("当前索引",index)
      let list   =[]
      list=this.daysList;
      console.log(',,,,,,',this.daysList[index]['edit'])
      if(this.daysList[index]['edit']==true){
        list[index]['edit']=false;
        list[index]['color']='';
         this.getCalendarCourseView(this.yearM+'-'+this.monthM,'');
      }else{
        list[index]['edit']=true;
        list[index]['color']='red';
        this.getCalendarCourseView(this.yearM+'-'+this.monthM,this.yearM+'-'+this.monthM+'-'+day);
        for(let i=0;i<list.length;i++){
          if(i>index||i<index){
                   list[i]['edit']=false;
                   list[i]['color']='';
          }
        }
      }
       this.daysList=list;
    },
    //下一个月
    nextMonth(year, month) {
          console.log(year,month)
          this.yearM=year;
          this.monthM=this.monthM+1
          if(this.monthM>12){
           this.yearM=parseInt(year+1);
            this.monthM=1
          }
          this.year=this.yearM;
          this.month=this.monthM;
          this.dayListPush(2)
          this.getCalendarCourseView(this.yearM+'-'+this.monthM);
    },
    //上一个月
    preMonth(year, month) {
          console.log(year,month)
          this.yearM=year;
          this.monthM=this.monthM-1
          if(this.monthM<1){
           this.yearM=parseInt(year-1);
            this.monthM=12
          }
          this.year=this.yearM;
          this.month=this.monthM;
          this.dayListPush(2)
          this.getCalendarCourseView(this.yearM+'-'+this.monthM);
    },
  },

  created: function() {
    let date = new Date();
    this.today = this.formatDate(
      date.getFullYear(),
      date.getMonth() + 1,
      date.getDate()
    );
    this.currentDay = this.today;
    this.initCalendar();

    //课程日历视图接口
    this.course_view();


    console.log("当月天数",)
    console.log('当前日期数组',this.daysList)


  },
  mounted(){
      this.$refs.lT.style.height=localStorage.getItem('heights')+'px'
      var date=new Date;
      var year=date.getFullYear();
      var month=date.getMonth()+1;
      this.yearM=year;
      this.monthM=month;
      this.dayListPush(1);
      this.getCalendarCourseView();

  },
  //
  formatDate(year, month, day) {
    var y = year;
    var m = month;
    if (m < 10) m = "0" + m;
    var d = day;
    if (d < 10) d = "0" + d;
    return y + "-" + m + "-" + d;
  },

  activated: function() {}
};
</script>
<style lang='less' scoped>
  .list-row-items{
    width:7.2rem;
    font-size: 0.35rem;
    color: #4d4d4d;
    overflow:hidden;
    text-overflow:ellipsis;
    white-space:nowrap
  }
.active{
        color:red!important;
        font-weight: bold!important;
}
.activeBC{
       color:#fff;
       background: red;
       border-radius: .2rem;

}
.list-date{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  li{
    width:14.15%;
    min-height:1rem;
    height: auto;
    margin-top: .5rem;
          .days-flex-colum{
        display: flex;
        flex-direction: column;
        text-align: center;
        min-height: 0rem;
        /*max-height: 1rem;*/
        overflow-y: auto;
        border:1px solid #ccc;
        margin-top: .1rem;
        border-radius: .2rem;
      }
    .days{
      height:.5rem;
      line-height: .5rem;
      text-align: center;
      .days-flex-colum{
        display: flex;
        flex-direction: column;
        text-align: center;
        min-height: 0rem;
        max-height: 1rem;
        overflow-y: auto;
        background: #EAD7D8;
      }
    }
            .cityDate{
          text-align: center;
        }
  }
}
.noDates{
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  margin: 0 auto;
}










@margin: 0.2rem 0.5rem 0.2rem 0.5rem;
@width: 0.1;
.container {
  background-color: #f5f5f5;
  padding-top: 54;
}

.activeHeight{
  margin-bottom: 1rem;
}

.calendar {
  /*position: relative;*/
  min-height: 1000;
  width: 690;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 40;
  background-color: #ffffff;
  border-radius: 20;
  box-shadow: 0 0 20 10 rgba(254, 79, 105, 0.1);
  height:auto;
  padding-bottom: .3rem;
}

.calendar .header {
  padding-top: 48;
  padding-bottom: 37;
}

.calendar .header .left {
  width: 150;
}

.calendar .header .right {
  width: 150;
  text-align: right;
}

.calendar .header .middle .month {
  padding: 0 30;
}

.calendar .hidden {
  visibility: hidden;
}

ul {
  list-style-type: none;
}

.weekdays {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  height:1rem;
  line-height: 1rem;
   background: rgb(244, 244, 244);
}

.weekdays li {
  display: inline-block;
  /*width: 13.6%;*/
  width: 90;
  text-align: center;
}

// .days {
//   display: flex;
//   flex-wrap: wrap;
//   /*justify-content: center;*/
// }

// .days li {
//   width: 14.2%;
//   height: 1.6rem;
//   text-align: center;
// }

// .days li .date-background {
//   position: relative;
//   height: 1.5rem;
//   line-height: 1rem;
//   // margin: 15;
//   color: #2a2a2a;
//   font-size: 16px;
//   font-weight: bold;
// }

// .days li .date {
//   height: 2rem;
//   // line-height: 61;
//   width: 100%;
// }

// .days .label1 {
//   // padding-top: 15;
//   // height: 23;
//   // line-height: 23;
// }

// .days .label {
//   margin-top: 20;
//   margin-left: 48%;
//   /* height: 23;
//    line-height: 23;*/
// }

// .days .date-background .label-start {
//   position: absolute;
//   top: 132%;
//   left: 50%;
// }

// .days .point {
//   width: 10;
//   height: 10;
//   border-radius: 50%;
//   background-color: #fe4f69;
// }

// .days .statu-cal {
//   color: #ff8194;
// }

// .days .statu-mense-single {
//   color: #ffffff;
//   margin-left: 20;
//   width: 61 !important;
//   background-color: #fe4f69;
//   border-radius: 50%;
// }

// .days .statu-mense-start {
//   color: #ffffff;
//   /* display: flex;
//    flex-direction:row-reverse;*/
//   float: right;
//   padding-right: 10;
//   width: 81 !important;
//   background-color: #fe4f69;
//   border-top-left-radius: 50%;
//   border-bottom-left-radius: 50%;
// }

// .days .statu-mense-end {
//   color: #ffffff;
//   padding-left: 15;
//   width: 81 !important;
//   background-color: #fe4f69;
//   border-top-right-radius: 50%;
//   border-bottom-right-radius: 50%;
//   box-sizing: border-box;
// }

// .days .statu-mense {
//   color: #ffffff;
//   background-color: #fe4f69;
// }

// .days .statu-safe {
//   color: #0d0d0d;
//   font-size: 14px;
//   font-weight: normal;
// }

// .days .statu-ovulation {
//   color: #fadb14;
// }

// .days .statu-ov {
//   background-image: url("https://gehx.oss-cn-hangzhou.aliyuncs.com/red-cal/ovulation.png");
//   background-position-x: center;
//   /*   background-position-y: center;*/
//   background-repeat: no-repeat;
//   background-size: 55 55;
//   color: #ffc069;
// }

// .days .selected {
//   position: absolute;
//   top: 1rem;
//   left: 0.6rem;
//   color: #fe4f69;
//   border: 2px solid #ea0f0f;
//   border-radius: 50%;
// }

//  .date-background .date {

//  }

.legend {
  height: 80;
  padding-right: 30;
}

.legend .item {
  display: flex;
  justify-content: center;
  align-items: center;
  /*width: 150;*/
  text-align: center;
}

.legend .item .legend-msg {
  height: 80;
  line-height: 80;
}

.legend .item .legend-point {
  height: 14;
  width: 14;
  margin-left: 29;
  margin-right: 19;
  border-radius: 50%;
}

.opration {
  margin-top: 68;
}

.opration .op-record .title {
  padding-left: 69;
}

.opration .op-record .content {
  padding-right: 80;
}

.opration .op-msg {
  text-align: center;
  margin-left: 165;
  margin-right: 165;
  height: 68;
  line-height: 68;
  width: 360;
  border-radius: 34;
  background-color: #cccccc;
}

.weui-switch-cp__input:checked ~ .weui-switch-cp__box,
.weui-switch:checked {
  border-color: #fe4d67;
  background-color: #fe4d67;
}
// 今日图片
.today-img {
  width: 30;
  height: 30;
}
.month {
  background: white;
  color: #0d0d0e;
  text-align: center;
  font-weight: bold;
  font-size: 18px;
}
.block_title {
  height: 1.3rem;
  line-height: 30px;
  margin: @margin;
  color: #0d0d0d;
  font-weight: normal;
  font-size: 14px;
  background: white;
  margin-top: 1rem;
}
.curriculum_member {
  background: #ffffff;
  height: 2.85rem;
  // box-sizing: border-box;
  margin:.15rem .3rem;
  // border: 1px solid rgba(167, 167, 167, 1);
  // border-radius: 16px;
  padding: 0.1rem 0.2rem;
  line-height: 2rem;
  .van-row {
    height: 0.5rem;
    padding: 0.1rem;
    .van-col {
      height: 0.5rem;
      line-height: 0.4rem;
      padding: 0.1rem;
      .van-field__control {
        height: 0.5rem;
        padding: 0.1rem;
      }
    }
  }
}
.container-new {
  height: 18rem;
  // padding-bottom: 1rem;
}
.container-new-flex{
  overflow-y: auto;
}
.listcontent {
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  padding-top: 0.3rem;
}
.appraise {
  margin-top: 0.5rem;
  font-weight: bold;
  color: #2a2a2a;
  font-size: 16px;
  padding-left:.3rem;
}
.appraise_ico {
  width: 0.1rem;
  height: 0.4rem;
  background-color: #e10913;
  display: inline-block;
}
.name {
  font-weight: bold;
  font-size: 15px;
  color: #2a2a2a;
}
.listappraise {
  margin-bottom: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/lkcollege/calendarCurriculum.vue